import React from "react";

import { GroupButtons } from "../../../../components/button/GroupButtons";
import { Button } from "../../../../components/newUI/button";
import PlusSvg from "../../../../components/svg/PlusSvg";
import { WorkTypesListHeaderProps } from "../model/workTypesList.types";

export const WorkTypesListHeader: React.FC<WorkTypesListHeaderProps> = ({
  activeStatus,
  onStatusChange,
  onCreate,
}) => (
  <div className={"mb-6 flex items-center justify-between gap-4 font-Manrope"}>
    <div className={"text-2xl font-semibold"}>Work Types</div>
    <div className={"flex gap-4"}>
      <GroupButtons
        buttons={[
          {
            label: "All",
            action: () => onStatusChange("all"),
            isActive: activeStatus === "all",
          },
          {
            label: "Active",
            action: () => onStatusChange("active"),
            isActive: activeStatus === "active",
          },
          {
            label: "Inactive",
            action: () => onStatusChange("inactive"),
            isActive: activeStatus === "inactive",
          },
        ]}
      />
      <Button
        type={"button"}
        autoWidth
        leftIcon={<PlusSvg />}
        onClick={onCreate}
        className={
          "border-[#6938EF] bg-[#6938EF] px-4 text-white hover:border-[#6938EF] hover:bg-[#6938EF]"
        }>
        New Work Type
      </Button>
    </div>
  </div>
);
